import React from 'react';
import { useAppConfig, useUsers } from '@/hooks/useShared';
import GameSetupForm from '@/components/GameSetupForm';

export default function NewGamePage() {
  const { loading: configLoading } = useAppConfig();
  const { loading: usersLoading } = useUsers();

  if (configLoading || usersLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-500">
        Loading...
      </div>
    );
  }

  return (
    <div className="py-6 px-4 pb-24 max-w-md mx-auto min-h-screen bg-[#f5f7f8]">
      <div className="bg-[#e8f5f0] border border-[#006855]/10 rounded-2xl p-5 mb-4">
        <div className="text-[10px] font-black uppercase tracking-[2px] text-[#006855]/70 mb-1">Game Setup</div>
        <h1 className="text-[22px] font-extrabold text-[#2c2f30] leading-tight">Schedule New Game</h1>
      </div>
      <GameSetupForm mode="create" />
    </div>
  );
}
